import styles from './cookie-preferences-placeholder.module.scss';

export function CookiePreferencesPlaceholder() {
  return (
    <div
      id="teconsent"
      className={styles['cookie-preferences-placeholder']}
      style={{ display: 'none !important' }}
    />
  );
}

export function openCookiesPreferences() {
  const el = document.querySelector<HTMLLinkElement>('#teconsent a');
  el?.click();
}
